module.exports = __webpack_public_path__ + "img/heart_gary.9d581ec8.png";